import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RouterProvider, createHashRouter } from "react-router-dom";

import "./App.css";
import { routing } from "./Routes/TotalRouter";
import { clearLocalToken } from "./Shared/Methods";
import {
  HandleSessionModal,
  UpdateLoginDate,
} from "./Store/Redux/Reducers/Authreducers";
import { userData } from "./Shared/Constants";
import CommonModal from "./Modals/CommonModal";
import SessionExpiredModalDemo from "./Modals/SessionExpiredModalDemo";
import { UpdateAlertData } from "./Store/Redux/Reducers/Dashboardreducers";
import instance from "./Services/Axios";

const route = createHashRouter(routing, { basename: "/" });

function App() {
  const { sessionModalShow } = useSelector((state: any) => state.Auth);
  const dispatch = useDispatch();
  const SessionAlertData: any = sessionStorage.getItem("AlertData");

  useEffect(() => {
    if (userData && userData !== null) {
      instance.defaults.baseURL = userData?.base_url;
      dispatch(UpdateLoginDate(userData));
    }
  }, [userData]);

  useEffect(() => {
    if (SessionAlertData && SessionAlertData !== null) {
      dispatch(UpdateAlertData(JSON.parse(SessionAlertData)));
    }
  }, [SessionAlertData]);

  return (
    <>
      <RouterProvider router={route} />
      {sessionModalShow ? (
        <CommonModal
          open={true}
          closable={false}
          width={400}
          Children={
            <SessionExpiredModalDemo
              handleSuccess={() => {
                clearLocalToken();
                dispatch(HandleSessionModal(false));
              }}
            />
          }
        />
      ) : null}
    </>
  );
}

export default App;
